import { Address } from '@shared/modules/address/model';

export namespace AddressUtils {
  export function getEmptyAddress(): Address.Address {
    return {
      label: '',
      placeId: '' as Address.PlaceId
    }
  }
}